module.exports = __webpack_public_path__ + "static/AWS-33aae304182da34457d3130bcf31ad3f.mp4";